import { LoggingHandler } from 'root/utils/errorReporting/LoggingHandler';

export default function handlePardotFormSubmit(formEl: HTMLFormElement) {
    const leadformEl = formEl.closest<HTMLElement>('.leadform');
    const loadingIndicatorEl = leadformEl?.querySelector<HTMLElement>(
        '[data-loader=ls-loader]'
    );
    if (loadingIndicatorEl) {
        handleLoadingIndicator(formEl, loadingIndicatorEl).showLoader();
        handleLoadingIndicator(formEl, loadingIndicatorEl).handleReturnToFormButton();

        // Honeypot field check
        const honeypotEl = formEl.querySelector<HTMLInputElement>('[name="fax"]');
        if (honeypotEl && honeypotEl.value) {
            LoggingHandler().logError('Pardot form honeypot field filled', {
                fileName: 'handlePardotFormSubmit.ts',
                searchTerm: 'honeypot',
                tags: ['forms', 'honeypot'],
                additionalData: {
                    honeypotValue: honeypotEl.value,
                },
            });

            handleLoadingIndicator(formEl, loadingIndicatorEl).hideSpinner();
            handleLoadingIndicator(formEl, loadingIndicatorEl).showErrorMessage();

            return;
        }
    }

    formEl.submit();
}

const handleLoadingIndicator = (
    formEl: HTMLFormElement,
    loadingIndicatorEl: HTMLElement
) => {
    const spinnerEl = loadingIndicatorEl.querySelector<HTMLElement>(
        '[data-select="form-landing-happy"]'
    );
    const errorFeedbackWrapper = loadingIndicatorEl.querySelector<HTMLElement>(
        '[data-select="form-landing-error"]'
    );
    const returnToFormButton = errorFeedbackWrapper?.querySelector<HTMLElement>(
        '[data-button="back-to-form"]'
    );

    const showLoader = () => {
        loadingIndicatorEl.classList.add('tw:block');
        formEl.classList.add('tw:hidden');
        formEl.classList.remove('tw:block');
    };

    const hideLoader = () => {
        loadingIndicatorEl.classList.remove('tw:block');
        formEl.classList.remove('tw:hidden');
        formEl.classList.add('tw:block');
    };

    const hideSpinner = () => {
        spinnerEl?.classList.add('tw:hidden');
    };

    const showSpinner = () => {
        spinnerEl?.classList.remove('tw:hidden');
    };

    const hideErrorMessage = () => {
        errorFeedbackWrapper?.classList.remove('tw:block');
    };

    const showErrorMessage = () => {
        errorFeedbackWrapper?.classList.add('tw:block', 'tw:h-auto');
    };

    const handleReturnToFormButton = () => {
        returnToFormButton?.classList.add('tw:mx-auto');
        returnToFormButton?.addEventListener('click', () => {
            hideErrorMessage();
            showSpinner();
            location.reload();
        });
    };

    return {
        showLoader,
        hideLoader,
        hideSpinner,
        showSpinner,
        hideErrorMessage,
        showErrorMessage,
        handleReturnToFormButton,
    };
};
